 const LoadFromLocalStorage = (item, key, setter) => {
  if(item != null && isLocalStorageSupported() ) {
    let value = localStorage.getItem(getAttrKeyForNesting(key, item.uuid) );
    value != undefined ? setter(value) : undefined
  }
}
export default LoadFromLocalStorage;
